import { useRef } from 'react';
import { useDebounceCallback } from './use-debounce-callback';

export type TapType = 'single' | 'double';
type TapFunctionType = (type: TapType, ...args: any[]) => any;
type InvokeTapFunctionType = (...args: any[]) => any;

const NO_TAP = 0;
const DOUBLE_TAP = 2;
const TAP_ELAPSED_TIME = 268; //ms

export const useContinuousTap = (tap: TapFunctionType): InvokeTapFunctionType => {
	/** Current number of continuous taps. */
	const continuousTapRef = useRef(NO_TAP);

	/** Single tap. */
	const debounceSingleTap = useDebounceCallback(
		(...args: any[]) => {
			continuousTapRef.current = NO_TAP;
			tap('single', ...args);
		},
		{
			wait: TAP_ELAPSED_TIME,
		}
	);

	return function invokeTap(...args: any[]): any {
		continuousTapRef.current++;
		/** Double tap. */
		if (continuousTapRef.current >= DOUBLE_TAP) {
			debounceSingleTap.cancel();
			continuousTapRef.current = NO_TAP;
			tap('double', ...args);
			return;
		}
		/** Single tap. */
		debounceSingleTap(...args);
	};
};
